import { ReactElement, useCallback, useContext } from 'react';

import { Typography } from '@mui/material';

import { ChangeDetectorContext } from '../../components/change-detector-context/ChangeDetectorContext';
import { ChangeDetectorContextModel } from '../../components/change-detector-context/models/change-detector-context.model';
import { ModalContext } from '../../components/modal/ModalContext';
import ModalDialog from '../../components/modal/ModalDialog';
import { ModalContextModel } from '../../components/modal/models/modal-context.model';
import Button from '../../components/ui/Button';
import { getButtonClickFunction } from './utils/get-button-click-function/get-button-click-function.util';
import { openModalWithDialogComponent } from './utils/open-modal-with-dialog-component/open-modal-with-dialog-component.util';

const useChangePrompt = (
  changePrompt: boolean,
  defaultFunction: () => void,
  title: JSX.Element,
  content: JSX.Element
): (() => void) => {
  const modalCtx = useContext(ModalContext) as ModalContextModel;
  const cdContext = useContext(
    ChangeDetectorContext
  ) as ChangeDetectorContextModel;

  const dialogComponent: ReactElement = (
    <ModalDialog
      content={content}
      title={title}
      extraButtons={[
        <Button
          onClick={getButtonClickFunction(
            defaultFunction,
            cdContext.setIsChanged,
            modalCtx.modalStateHandler
          )}
          className="dialog-btn dialog-btn-yes"
          key={'prompt-button'}
        >
          <Typography className="dialog-btn-yes-text">Yes</Typography>
        </Button>,
      ]}
    />
  );

  return useCallback<() => void>(
    changePrompt && cdContext.isChanged
      ? openModalWithDialogComponent(dialogComponent, modalCtx)
      : () => defaultFunction(),
    [changePrompt, cdContext.isChanged]
  );
};

export default useChangePrompt;
